const API_URL = process.env.REACT_APP_API_URL;

export async function getColors() {
    const response = await fetch(`${API_URL}/couleur`, {
        method: "GET",
        credentials: "include",
    });

    if (!response.ok) {
        throw new Error("Erreur lors du chargement des couleurs");
    }

    return response.json();
}

export async function createColor(colorData) {
    const response = await fetch(`${API_URL}/couleur`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            couleur: {
                nom: colorData.name,
                hex: colorData.hex,
            }
        }),
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || "Erreur lors de la création de la couleur");
    }

    return response.json();
}

export async function updateColor(colorId, colorData) {
    const response = await fetch(`${API_URL}/couleur/${colorId}`, {
        method: "PUT",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            couleur: {
                nom: colorData.name ?? null,
                hex: colorData.hex ?? null,
            }
        }),
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || "Erreur lors de la mise à jour de la couleur");
    }

    return response.json();
}

export async function deleteColor(colorId) {
    const response = await fetch(`${API_URL}/couleur/${colorId}`, {
        method: "DELETE",
        credentials: "include",
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || "Erreur lors de la suppression de la couleur");
    }

    return response.json();
}